import {useEffect, useState} from "react";
import NOIMAGE from "../../assets/images/NOIMAGE.png";
import s from "./ImageWithPlaceholder.module.scss";

const ImageWithPlaceholder = ({ src, alt, className }) => {
    const [loaded, setLoaded] = useState(false);
    const [imgSrc, setImgSrc] = useState(src);
    useEffect(() => {
        setImgSrc(src);
        setLoaded(false);
    }, [src]);
    return (
        <div className={`${s.wrapper} ${className || ""}`}>
            {/* show placeholder UNTIL image loads */}
            {!loaded && <div className={s.placeholder}></div>}

            <img
                src={imgSrc}
                alt={alt}
                onLoad={() => setLoaded(true)}
                onError={() => {
                    setImgSrc(NOIMAGE);
                    setLoaded(true)
                }} // prevent stuck loader
                className={`${s.image} ${loaded ? s.show : ""}`}
            />
        </div>
    );
};

export default ImageWithPlaceholder;